import React from "react";
import { formatShopPrice } from "constants/shopVouchers";
import { voucherBalanceBreakdown } from "utils/shopBasket";

const VoucherBalanceOption = ({ totalCents, balanceCents, checked, onChange }) => {
  if (!balanceCents || !totalCents) return null;
  const { balanceAppliedCents, amountDueCents } = voucherBalanceBreakdown(
    totalCents, balanceCents, checked
  );
  return (
    <div className="shop-balance">
      <label className="shop-gift">
        <input type="checkbox" checked={checked} onChange={(event) => onChange(event.target.checked)} />
        <span>Guthaben verwenden ({formatShopPrice(balanceCents)} verfügbar)</span>
      </label>
      {checked && (
        <div className="shop-balance-breakdown">
          <span>Davon mit Guthaben</span><strong>−{formatShopPrice(balanceAppliedCents)}</strong>
          <span>{amountDueCents ? "Online zu zahlen" : "Noch zu zahlen"}</span>
          <strong>{formatShopPrice(amountDueCents)}</strong>
        </div>
      )}
    </div>
  );
};

export default VoucherBalanceOption;
